import router from './router'
import store from './store'
import getPageTitle from '@/utils/get-page-title'
import { getXAuthToken } from './utils/auth' // get token from cookie

const whiteList = ["/login", "/register", "/register/confirm", "/forgotpassword", "/forgotpassword/check", '/sign-agent', '/subscriptions', '/order', '/order-finish','/terms']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    // start progress bar
    document.title = getPageTitle(to.meta.title)

    const hasTokenMember = getXAuthToken()
    // console.log('hasTokenMember', hasTokenMember)

    if (hasTokenMember) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next()
        } else {
            const hasRoles = store.getters.rolesMember && store.getters.rolesMember.length > 0
            // console.log('hasRoles', hasRoles)

            if (hasRoles) {
                // console.log('hasRolesx', hasRoles)

                next()

            } else {
                try {

                    // store.dispatch('referral/check')
                    const { data } = await store.dispatch('login/getProfile')
                    const { roles } = data
                    const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
                    // console.log('accessRoutesx', accessRoutes)
                    // dynamically add accessible routes
                    router.addRoutes(accessRoutes)
                    next({
                        ...to,
                        replace: true
                    })
                } catch (error) {
                    console.log('catch', error)

                    // remove token and go to login page to re-login
                    await store.dispatch('login/removeXAuthToken')
                    next(`/login?redirect=${to.path}`)
                }
                // next()
                // await store.dispatch('login/removeXAuthToken')
                // next(`/login?redirect=${to.path}`)

            }
        }
    } else {
        /* has no token */
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
        }
    }
    // set page title
    // next()

})

router.afterEach(() => {
    // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js